import React from 'react'
import { handleEvtClicks } from '../js/helper'

import '@govtechsg/sgds/css/sgds.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle'

import OneMapLogo from '../assets/icons/navbarLogo.svg'

const NavbarComponent = () => {

  return (
    <>
      <nav className='navbar navbar-expand-lg'>
        <div className='container-fluid'>
          <a className='navbar-brand' href={`${process.env.REACT_APP_PUBLIC_URL}/`}>
            <img src={OneMapLogo} alt='OneMap' width='48' height='48' />
          </a>
          <div className='justify-content-end'>
          <button className='navbar-toggler' type='button' data-bs-toggle='collapse' data-bs-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul className='navbar-nav w-100'>
              <li className='nav-item'>
                <a className='nav-link' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/`}
                  onClick={() => { new handleEvtClicks('click', { select: '/' }) }}>Home</a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/register`}
                onClick={()=>{new handleEvtClicks('click', {select: 'Register'})}}>Register</a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/maps`}
                onClick={()=>{new handleEvtClicks('click', {select: 'APIDocs'})}}>API Documentation</a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' aria-current='page' href={`${process.env.REACT_APP_PUBLIC_URL}/mcp`}
                onClick={()=>{new handleEvtClicks('click', {select: 'MCP'})}}>MCP</a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' href={`${process.env.REACT_APP_PUBLIC_URL}/docs/blog`}
                onClick={()=>{new handleEvtClicks('click', {select: 'Blog'})}}>Blog</a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' href={`${process.env.REACT_APP_PUBLIC_URL}/contactus`}
                onClick={()=>{new handleEvtClicks('click', {select: 'ContactUs'})}}>Contact Us</a>
              </li>
              <li className='nav-item dropdown'>
                <a className='nav-link dropdown-toggle' role='button' data-bs-toggle='dropdown' aria-expanded='false'>
                  Account Settings
                </a>
                <ul className='dropdown-menu dropdown-menu-end'>
                  <li>
                    <a className='dropdown-item' href={`${process.env.REACT_APP_PUBLIC_URL}/registerconfirm`}
                    onClick={()=>{new handleEvtClicks('click', {select: 'VerifyConfirmation'})}}>
                      Verify Confirmation Code
                    </a>
                  </li>
                  <li><a className='dropdown-item' href={`${process.env.REACT_APP_PUBLIC_URL}/forgetpassword`}
                  onClick={()=>{new handleEvtClicks('click', {select: 'ForgetPassword'})}}>Forget Password</a></li>
                </ul>
              </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

export default NavbarComponent